export type GoalRuleState = {
  score: number;
  streak: number;
  maxStreak: number;
  goals: number;
  wrong: number;
  answered: number;
};

export function initialGoalRuleState(): GoalRuleState {
  return { score: 0, streak: 0, maxStreak: 0, goals: 0, wrong: 0, answered: 0 };
}

export function applyGoalAnswer(state: GoalRuleState, correct: boolean) {
  const nextStreak = correct ? state.streak + 1 : 0;
  const baseScore = correct ? 100 : 0;
  const streakBonus = correct ? Math.min(100, Math.max(0, nextStreak - 1) * 25) : 0;
  const scoreDelta = baseScore + streakBonus;
  return {
    state: {
      score: state.score + scoreDelta,
      streak: nextStreak,
      maxStreak: Math.max(state.maxStreak, nextStreak),
      goals: state.goals + (correct ? 1 : 0),
      wrong: state.wrong + (correct ? 0 : 1),
      answered: state.answered + 1,
    },
    breakdown: { baseScore, streakBonus },
    scoreDelta,
  };
}
